module.exports = __webpack_public_path__ + "static/QTUM-280c5792d806eb2719824ea1e5feeb4a.svg";